import { useCallback } from 'react'
import { Account, Page } from '../../../types'
import { HttpClientConfig, useHttpClientConfig } from '../../useHttpClientConfig'
import { AccountsFilters, makeGetAccounts } from './accounts'

interface AccountsService {
  getAccounts: (filters: AccountsFilters) => Promise<Page<Account>>
  isReady: boolean
}

const useAccountsService = (): AccountsService => {
  const { config } = useHttpClientConfig()

  const getAccounts = useCallback(makeGetAccounts(config as HttpClientConfig), [config])

  return {
    getAccounts,
    isReady: Boolean(config),
  }
}

export { useAccountsService }
